import { render } from "./NewOrderPage.vue?vue&type=template&id=6ada14e3&scoped=true"
import script from "./NewOrderPage.vue?vue&type=script&lang=js"
export * from "./NewOrderPage.vue?vue&type=script&lang=js"

import "./NewOrderPage.vue?vue&type=style&index=0&id=6ada14e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ada14e3"]])

export default __exports__